import {
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHF,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedMultiDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import { CountryService } from "../../../services/common/CountryService";
import { SelectAllOrRemoveAllProvinces } from "../../CommonComponents/SelectAllOrRemoveAllProvinces";
import { useNavigateToLogout } from "../../../common/Common";

interface IPayrollEHTEarningsSetupFieldsPanel {
	countryList: any;
	earningsList: any;
	provinceDDLItems: (value: any) => void;
	formMethods: any;
}

export const PayrollEHTEarningsSetupFieldsPanel: FC<
	IPayrollEHTEarningsSetupFieldsPanel
> = ({ countryList, provinceDDLItems, earningsList, formMethods }) => {
	const [provinceDDL, setprovinceDDL] = useState([]);
	const navigateToLogout = useNavigateToLogout();

	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						const ontarioAndBCProvinceDDL = response.filter(
							(x: any) =>
								x.label === "Ontario" || x.label === "British Columbia"
						);
				
						setprovinceDDL(ontarioAndBCProvinceDDL);
						provinceDDLItems(ontarioAndBCProvinceDDL);
					} catch (err) {
						console.error("error", err);
					}
				})();
			}
		}
	}, [countryList]);
	return (
		<Box>
			<EnhancedDropDownRHFWithLabel
				label="Earning"
				selectName="earningId"
				testId={`earningId`}
				labelPosition={LabelPosition.Top}
				items={earningsList ?? []}
			/>
			<EnhancedMultiDropDownRHFWithLabel
				selectName="province"
				items={provinceDDL}
				testId="province"
				label="Provinces"
			/>
			<SelectAllOrRemoveAllProvinces formMethods={formMethods} provinceDDL={provinceDDL} />
			<EnhancedIOSSwitchRHFWithLabel
				name="enable"
				checked={false}
				testId="switch"
				// onSelectionChangeHandler={() => alert('clicked')}
				label={"Enable"}
			/>
			<RHookFormDatePicker
				name="effectiveDate"
				testId="123"
				label="Effective Date"
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormDatePicker
				name="endDate"
				testId="123"
				label="End Date"
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
